<div class="page">
  <div class="portal-item-box">
    <div class="portal-item" *ngFor="let item of ps.itemCategoryList[0].Items" (click)="openUploader(item)">
      <div class="portal-item-img">
        <img [src]="ps.itemImages[item.Id] ?? 'assets/images/item-placeholder.png'" />
      </div>
      <div class="portal-item-detail">
        <h1>{{ item.Title }}</h1>
        <span>{{ item.Code }}</span>
      </div>
    </div>
  </div>
</div>
